/*
 * Page picker. Jumps to the page chosen in a [data-page-select] menu while
 * preserving whatever filters and sort are already on the URL.
 *
 * The listener is delegated from the document and bound once, because Dawn's
 * facets.js replaces the innerHTML of #ProductGridContainer when a filter
 * changes -- inline scripts inside that markup would not re-execute.
 */
(function () {
  if (window.paginationJumpBound) return;
  window.paginationJumpBound = true;

  document.addEventListener('change', function (event) {
    var select = event.target;

    if (!select || select.tagName !== 'SELECT') return;
    if (!select.hasAttribute('data-page-select')) return;

    var url = new URL(window.location.href);
    url.searchParams.set('page', select.value);
    window.location.href = url.toString();
  });
})();
